import { isSSR as u, isBrowser as c, isDev as i } from "@fond-of/env";
const l = (t, e) => {
  var o, r;
  u() || (r = (o = window.DD_RUM) == null ? void 0 : o.addError) == null || r.call(o, t, e);
}, d = (t = "XXX") => ({
  "data-dd-privacy": "mask",
  // Anonymize in datadog
  "data-dd-action-name": t
  // Anonymize in datadog
}), f = (t, e) => {
  console.error(t, e);
}, p = (t, e) => {
  l(t, e), c() && i(window.location.host) && f(t, e);
}, v = () => ({
  "data-cs-mask": !0
  // Anonymize in contentsquare
}), a = (t = "XXX") => ({
  ...d(t),
  ...v()
}), y = {
  mounted: (t, e) => {
    if (e.value === !1)
      return;
    const o = a(e.value);
    for (const [r, s] of Object.entries(o))
      t.setAttribute(r, String(s));
  },
  getSSRProps: (t) => {
    if (t.value !== !1)
      return a(t.value);
  }
}, n = (t) => ({ "data-testid": t }), S = {
  mounted: (t, e) => {
    if (e.value === !1)
      return;
    const o = n(e.value);
    for (const [r, s] of Object.entries(o))
      t.setAttribute(r, s);
  },
  getSSRProps: (t) => {
    if (t.value !== !1)
      return n(t.value);
  }
};
export {
  a as getAnonymizeProps,
  n as getTestProps,
  p as trackError,
  y as vAnonymize,
  S as vE2eTestId
};
//# sourceMappingURL=telemetry.js.map
